import React from 'react';

export default function ServiceUnavailablePage() {
  const handleRetry = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <img
          src="/logos/logo-02.svg"
          alt="OutdoorGuides"
          className="h-12 mx-auto mb-8"
        />

        <div className="mx-auto w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-6">
          <svg className="w-10 h-10 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-3">
          We&apos;re experiencing technical difficulties
        </h1>

        <p className="text-base text-gray-600 mb-8">
          Our team is working on it. Please try again in a few minutes.
        </p>

        <button
          onClick={handleRetry}
          className="px-8 py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition font-semibold text-base"
        >
          Try Again
        </button>

        <p className="mt-8 text-sm text-gray-400">
          If this problem persists, contact{' '}
          <a href="mailto:support@outdoorguides.com" className="text-emerald-600 hover:text-emerald-700 underline">
            support@outdoorguides.com
          </a>
        </p>
      </div>
    </div>
  );
}
